import { connectRouter } from 'connected-react-router';
import { combineReducers } from 'redux';
import localForage from 'localforage';
import { createMigrate, persistReducer } from 'redux-persist';
import claimSlice from '../claimSlice/claimSlice';
import appStateSlice from '../appStateSlice/appStateSlice';
import history from '../../../history';
import sliceNames from '../../constants/sliceNames';
import claimMigration from '../../migrations/claim/claimMigration';

export const persistClaimSliceConfig = {
    key: sliceNames.claimSlice,
    versions: 1,
    migrate: createMigrate(claimMigration, { debug: false }),
    storage: localForage,
    blacklist: ['selectedClaimInfoIndex'],
};

export const persistAppStateSliceConfig = {
    key: sliceNames.appStateSlice,
    versions: 1,
    migrate: createMigrate(claimMigration, { debug: false }),
    storage: localForage,
    blacklist: ['loadingModalFlag', 'zipCodeFailedRegex', 'claimNumberFailedRegex'],
};

const rootReducer = combineReducers({
    appState: persistReducer(persistAppStateSliceConfig, appStateSlice),
    claim: persistReducer(persistClaimSliceConfig, claimSlice),
    router: connectRouter(history),
});

export default rootReducer;
